import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';

// function rand() {
//   return Math.round(Math.random() * 20) - 10;
// }

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles(theme => ({
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 3, 3),
    borderRadius: 8,
    '& h2': {
      fontSize: '18px',
      marginBottom: 14,
      fontFamily: 'Conv_AtlasGrotesk-Medium-App',
    },
    '& p': {
      fontSize: '14px',
      fontWeight: 400,
      marginBottom: 10,
    },
  },
  confirmationBtn: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingTop: 16,
    marginTop: 20,
    borderTop: '0.5px solid #cccccc40',
    '& button': {
      fontSize: '14px',
      lineHeight: '42px',
      height: '42px',
      textAlign: 'center',
      color: '#fff',
      background: '#000',
      fontFamily: 'Conv_AtlasGrotesk-Medium-App',
      textTransform: 'inherit',
      marginLeft: '20px',
      padding: '0 16px',
      borderRadius: '0px',
      '&:first-child': {
        background: 'transparent !important',
        color: '#000',
      },
      '&:hover': {
        background: '#000',
        boxShadow: 'none',
      },
    },
  },
}));

export default function ConfirmationPopup({
  ConfirmationDenyHandler,
  confirmationHandler,
}) {
  const classes = useStyles();
  const [modalStyle] = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(true);
  const handleClose = () => {
    setOpen(false);
  };

  const body = (
    <div style={modalStyle} className={classes.paper}>
      <h2 id="simple-modal-title">Modify Smart Keys</h2>
      <p id="simple-modal-description">Are you sure you want to continue?</p>
      <div className={classes.confirmationBtn}>
        <Button onClick={ConfirmationDenyHandler}>No, don’t</Button>
        <Button onClick={confirmationHandler}>Yes, continue</Button>
      </div>
    </div>
  );

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {body}
      </Modal>
    </div>
  );
}
